module.exports = __webpack_public_path__ + "d02fffb6890e4f28023dd149916d1b8a.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/assets/fonts/RobotoCondensed-Italic.ttf
// module id = 505
// module chunks = 0